import { CaptionsButton as CaptionsButton$1 } from "../../../../../ui/captions-button/component.js";
import ForwardRef from "../../../../../icons/dist/react/default/captions-off.js";
import ForwardRef$1 from "../../../../../icons/dist/react/default/captions-on.js";
import { Button } from "../../../shared/components/buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/default-video/components/buttons/captions-button.tsx
/** @jsxImportSource react */
function CaptionsButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(CaptionsButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-captions-button", resolveClassName(className, state)),
		...props,
		children: [/* @__PURE__ */ jsx(ForwardRef, { className: cn("media-button-icon", "media-captions-button-off-icon") }), /* @__PURE__ */ jsx(ForwardRef$1, { className: cn("media-button-icon", "media-captions-button-on-icon") })]
	});
}
//#endregion
export { CaptionsButton };

//# sourceMappingURL=captions-button.js.map